import { Address } from '../../domain/address.domain';
import { PartyGroupResponseList, AddressUsageCd } from '../../domain/user-profile.domain';

export interface W8BenProfile {
  birthDt: string;
  citizenship: string;
  givenName: string;
  middleName?: string;
  familyName: string;
  legalName?: string;
  identifications?: Array<W8BenIdentification>;
  ssn?: string;
  contactStreetAddresses: Array<W8BenContactAddress>;
  residenceAddressLines?: Array<string>;
  mailingAddressLines?: Array<string>;
  partyGroupResponseList: Array<PartyGroupResponseList>;
  ftinNotRequired: boolean;
}

export type W8BenAddressUsageCd = 'HOME_ADDRESS' | 'MAILING_ADDRESS';

export interface W8BenContactAddress {
  usageCd: W8BenAddressUsageCd | AddressUsageCd;
  address: W8BenAddress;
}

export type W8BenAddress = Address;

export interface W8BenFormProfile {
  birthDt?: string;
  citizenship?: string;
  givenName?: string;
  middleName?: string;
  familyName?: string;
  signed?: boolean;
  drafts: W8BenFormDraft;
  updateType: Array<W8BenUpdateType>;
  partyGroupResponseList?: Array<PartyGroupResponseList>;
  ftinNotRequired: boolean;
}

export interface W8BenFormDraft {
  streetAddresses?: Array<W8BenContactAddress>;
  identifications?: Array<W8BenFormDraftIdentification>;
}

export interface W8BenFormDraftIdentification {
  identification?: W8BenIdentification;
}

export type W8BenUpdateType = 'IDENTIFICATION' | 'ADDRESS';

export type W8BenIdentificationType = 'SIN' | 'SSN' | 'FTIN' | 'ITIN';

export interface W8BenIdentification {
  identificationNum: string;
  typeCd: W8BenIdentificationType;
}

export type W8BenFormBase64 = string;

export type W8BenTaggingFlowType = 'n/a' | 'a' | 'b' | 'c' | 'd' | 'e' | 'f';

export interface W8BenTagging {
  modalName: W8BenModalName;
  flow: W8BenTaggingFlowType;
}

export enum W8BenModalName {
  UPDATE = 'update',
  UPDATE_PR = 'update-pr',
  TAX_RESIDENCY = 'tax-residency',
  US_TIN = 'US TIN',
  REVIEW = 'review',
  SUCCESS = 'success',
  SPECIAL_RATE_CONDITION = 'special-rate-condition',
  DETAILS = 'details',
  CONTACT_US = 'contactus'
}
